import React, { useState, useEffect, useRef } from 'react';
import { Button, Card, Tabs, Skeleton, Empty, Carousel } from 'antd';
import CustomPagination from '../../components/common/CustomPagination';
import { formatReadingTime } from '../../utils/Utils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import heroBanner from '../../assets/images/education_hero_banner.png';
import httpClient from '../../utils/HttpClient';
import { objectToQuery } from '../../utils/Utils';
import { TECHNICAL_CATEGORY_URL, TECHNICAL_URL, COURSES_CATEGORY_URL, TEACHER_URL } from '../../constants/Url';
import { 
  setEducationTechnicalCategoryAction, 
  setEducationTechnicalsByCategoryAction, 
  setEducationCourseCategoryAction, 
  setEducationTeachersAction, 
  setEducationBannersAction
} from '../../modules/dataWebsite/actions';
import PROModal from '../../components/PROModal';
import AuthModal from '../../components/auth/AuthModal';
import { useMemberAccess } from '../../hooks/useMemberAccess';

export default function EducationPage() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const carouselRef = useRef(null);
  const authModalRef = useRef();
  const user = useSelector((state) => state.authReducer);
  const { hasNoActiveMembership } = useMemberAccess();
  const [isMemberGateOpen, setIsMemberGateOpen] = useState(false);

  const handleNavigate = (path, state) => {
    if (!user?.token) {
      authModalRef.current?.open();
    } else if (!user?.user?.completedTS) {
      authModalRef.current?.open('REGISTER');
    } else if (hasNoActiveMembership()) {
      setIsMemberGateOpen(true);
    } else {
      navigate(path, state ? { state } : undefined);
    }
  };
  
  // Connect mapped states to Redux
  // const technicalCategory = useSelector((state) => state.dataWebsiteReducer?.technicalCategoryData) || [];
  const technicalCategory =  [
    {
      name: t('menu_tech_showcase'),
      value: "技术展示",
      description: t('menu_tech_showcase_sub'),
      _id:"技术展示"
    },
    {
      name: t('menu_trivia'),
      value: "冷知识",
      description: t('menu_trivia_sub'),
      _id:"冷知识"
    }
  ];
  const technicalsByCategoryId = useSelector((state) => state.dataWebsiteReducer?.technicalsByCategoryData) || {};
  const courseCategories = useSelector((state) => state.dataWebsiteReducer?.courseCategoryData) || [];
  const teachers = useSelector((state) => state.dataWebsiteReducer?.courseTeacherData) || [];

  const [activeTab, setActiveTab] = useState('all');
  const [classroomPage, setClassroomPage] = useState(1);
  const [teacherPageSize, setTeacherPageSize] = useState(8);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(8);
  const [loading, setLoading] = useState(true);
  const [loadingTeachers, setLoadingTeachers] = useState(false);
  const [totalTeachers, setTotalTeachers] = useState(0);
  const [bannerImagess, setBannerImages] = useState([]);
  const bannerImages = useSelector((state) => state.dataWebsiteReducer?.educationBanners);

  // const fetchTechnicalCategory = async () => {
  //   try {
  //     const res = await httpClient.get(objectToQuery(TECHNICAL_CATEGORY_URL))
  //       .then(res => res.data)
  //       .catch(error => ({ status: 500, message: error?.message }));

  //     if (res.status === 200) {
  //       setEducationTechnicalCategoryAction([...res.data]);
  //       const fetchPromises = res.data.map(category => fetchTechnicalForCategory(category));
  //       const results = await Promise.all(fetchPromises);
        
  //       const newDict = {};
  //       results.forEach(result => {
  //         if (result) {
  //           newDict[result.categoryId] = result.data;
  //         }
  //       });
  //       setEducationTechnicalsByCategoryAction(newDict);
  //     } else {
  //       setEducationTechnicalCategoryAction([]);
  //     }
  //   } catch (error) {
  //     console.error('fetchTechnicalCategory -> error', error);
  //   }
  // };

  const fetchTechnicalForCategory = async (category) => {
    try {
      const payload = {
        keyword: '',
        category: category.value,
        categoryId: category._id || category.id,
        releaseYear: 'ALL',
        pageNo: 1,
        pageSize: 3
      };
      const res = await httpClient.get(objectToQuery(TECHNICAL_URL, payload))
        .then(res => res.data)
        .catch(error => ({ status: 500, message: error?.message }));

      if (res.status === 200) {
        return { categoryId: category._id || category.id, data: res.data };
      }
    } catch (error) {
      console.error('fetchTechnicalForCategory -> error', error);
    }
    return null;
  };

  const fetchCourseCategories = async () => {
    try {
      const res = await httpClient.get(objectToQuery(COURSES_CATEGORY_URL))
        .then(res => res.data)
        .catch(error => ({ status: 500, message: error?.message }));

      if (res.status === 200 && res.data) {
        setEducationCourseCategoryAction([{ _id: 'all', name: '全部' }, ...res.data]);
      }
    } catch (error) {
      console.error('fetchCourseCategories error', error);
    }
  };

  const fetchBanners = async () => {
    try {
      const payload = {
        pageNo: 1,
        pageSize: 9,
        "sortKeys[privateFile.uploadedTS]": "asc",
        category: "技术与教育"
      };
      const res = await httpClient.get(objectToQuery("/banners", payload))
        .then(res => res.data)
        .catch(() => null);

      if (res && res.status === 200 && res.data) {
        const images = res.data.flatMap(b => b.images || []);
        // setBannerImages(images);
        dispatch(setEducationBannersAction(images));
      }
    } catch (error) {
      console.error('fetchBanners error', error);
    }
  };



  const fetchTeachers = async () => {
    try {
      setLoadingTeachers(true);
      const categoryIdFilter = activeTab === 'all' ? '' : activeTab;
      const payload = {
        keyword: '',
        categoryId: categoryIdFilter,
        pageNo: classroomPage,
        pageSize: teacherPageSize
      };
      const res = await httpClient.get(objectToQuery(TEACHER_URL, payload))
        .then(res => res.data)
        .catch(error => ({ status: 500, message: error?.message }));

      if (res.status === 200) {
        setEducationTeachersAction(res.data || []);
        setTotalTeachers(res.total || res.data?.length || 0);
      } else {
        setEducationTeachersAction([]);
        setTotalTeachers(0);
      }
    } catch (error) {
      console.error('fetchTeachers error', error);
    } finally {
      setLoadingTeachers(false);
    }
  };

  useEffect(() => {
    const initData = async () => {
      try {
        setLoading(true);
        
        // Fetch categories and teachers in parallel
        await Promise.all([
          fetchCourseCategories(),
          fetchTeachers(),
          fetchBanners()
        ]);

        // Fetch technicals for each hardcoded category
        const fetchPromises = technicalCategory.map(category => fetchTechnicalForCategory(category));
        const results = await Promise.all(fetchPromises);
        
        // Store results in Redux dictionary format
        const newDict = {};
        results.forEach(result => {
          if (result) {
            newDict[result.categoryId] = result.data;
          }
        });
        
        // You'll need to dispatch this if it's connected, or we can use local state if not. 
        // Assuming setEducationTechnicalsByCategoryAction works via Redux dispatch.
        // Wait, setEducationTechnicalsByCategoryAction is an action creator imported above,
        // but it's not wrapped in dispatch. We should import dispatch.
        // Actually I will assume the system handles it or it was a custom hook? 
        // Let's just look at how it was used in the commented code: setEducationTechnicalsByCategoryAction(newDict);
        // I'll call it directly since that's what the old code did.
        setEducationTechnicalsByCategoryAction(newDict);
        
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    initData();
  }, []);

  useEffect(() => {
    const reloadTeachers = async () => {
      try {
        await fetchTeachers();
      } catch (error) {
        console.error(error);
      }
    };
    reloadTeachers();
  }, [activeTab, classroomPage, teacherPageSize]);

  if (loading && (!bannerImages || bannerImages.length === 0)) {
    return (
      <div className="w-full min-h-screen pb-16 bg-[#fcfdfe]">
        {/* Static Banner - No Skeleton */}
        <div 
          className="w-full aspect-[21/9] sm:aspect-[24/9] md:h-[600px] bg-cover bg-center relative flex items-center"
        >
          <Skeleton.Image className="!w-full !h-full" active />
        </div>

        {/* Content Skeletons */}
        <div className="max-w-[1263px] mx-auto px-4 sm:px-6 lg:px-8 mt-12 sm:mt-16 flex flex-col gap-16">
          {/* Section 1 Skeleton */}
          <div className="w-full">
            <div className="pb-4 mb-6 border-b border-gray-100 flex justify-between items-end">
              <Skeleton.Input active size="default" style={{ width: '120px' }} />
              <Skeleton.Input active size="small" style={{ width: '80px' }} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="bg-white rounded-lg border border-gray-100 p-5 sm:p-6 flex flex-col gap-4">
                  <div className="w-full aspect-[4/3] rounded-md bg-gray-50 flex items-center justify-center overflow-hidden">
                    <Skeleton.Image className="!w-full !h-full" active />
                  </div>
                  <Skeleton.Input active size="default" style={{ width: '80%' }} />
                  <Skeleton active paragraph={{ rows: 2 }} title={false} />
                </div>
              ))}
            </div>
          </div>

          {/* Section 2 Skeleton */}
          <div className="w-full">
            <div className="pb-4 mb-6 border-b border-gray-100 flex justify-between items-end">
              <Skeleton.Input active size="default" style={{ width: '120px' }} />
              <Skeleton.Input active size="small" style={{ width: '80px' }} />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
              {Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="bg-white rounded-lg border border-gray-100 p-5 sm:p-6 flex flex-col gap-4">
                  <div className="w-full aspect-[4/3] rounded-md bg-gray-50 flex items-center justify-center overflow-hidden">
                    <Skeleton.Image className="!w-full !h-full" active />
                  </div>
                  <Skeleton.Input active size="default" style={{ width: '80%' }} />
                  <Skeleton active paragraph={{ rows: 2 }} title={false} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
    <div className="w-full min-h-screen pb-16 bg-[#fcfdfe]">
      
      {/* ── Hero Masterclass Banner ── */}
      <div className="w-full aspect-[21/9] sm:aspect-[24/9] md:h-[600px] relative flex items-center overflow-hidden bg-[#1a1a1a] group">
        
        {/* Background Carousel */}
        <div className="absolute inset-0 z-0">
          {bannerImages.length > 0 ? (
            <Carousel ref={carouselRef} autoplay effect="fade" dots={bannerImages.length > 1 ? true : false} className="w-full h-full [&_.slick-dots]:bottom-6">
              {bannerImages.map((img) => (
                <div key={img._id} className="w-full aspect-[21/9] sm:aspect-[24/9] md:h-[600px]">
                  <img src={img.url} alt={img.name} className="w-full h-full object-cover" />
                </div>
              ))}
            </Carousel>
          ) : (
            <div 
              className="w-full h-full bg-cover bg-center"
              style={{ backgroundImage: `url(${heroBanner})` }}
            />
          )}
          {/* Dark Overlay for Text Visibility */}
          <div className="absolute inset-0 bg-black/55 pointer-events-none" />
        </div>

        {/* Navigation Arrows */}
        {bannerImages.length > 1 && (
          <>
            <button 
              onClick={() => carouselRef.current?.prev()}
              className="absolute left-4 sm:left-8 z-20 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white opacity-0 group-hover:opacity-100 transition-all duration-300 cursor-pointer border-none"
            >
              <LeftOutlined />
            </button>
            <button 
              onClick={() => carouselRef.current?.next()}
              className="absolute right-4 sm:right-8 z-20 w-10 h-10 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/40 backdrop-blur-sm text-white opacity-0 group-hover:opacity-100 transition-all duration-300 cursor-pointer border-none"
            >
              <RightOutlined />
            </button>
          </>
        )}

        {/* Fixed Foreground Text */}
        <div className="max-w-[1263px] mx-auto px-4 sm:px-6 lg:px-8 w-full z-10 text-white relative pointer-events-none">
          <div className="max-w-[650px] flex flex-col gap-2.5 sm:gap-4 items-start text-left pointer-events-auto">
            <span className="text-[11px] sm:text-xs font-bold tracking-widest text-pink-400 uppercase">
              {t('title_edu_1')}
            </span>
            <h1 className="text-2xl sm:text-4xl md:text-5xl font-extrabold text-white leading-tight m-0">
              {t("title_edu_2")} <span className="bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400 bg-clip-text text-transparent">{t("title_edu_3")}</span>
            </h1>
            <p className="text-gray-300 text-xs sm:text-[14px] leading-relaxed m-0 mt-2 max-w-[560px]">
              {t('title_edu_description')}
            </p>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="max-w-[1263px] mx-auto px-4 sm:px-6 lg:px-8 mt-12 sm:mt-16 flex flex-col gap-16 sm:gap-24">
        
        {/* Dynamic Category Sections */}
        {technicalCategory.map((category) => {
          const matchingTechnicals = technicalsByCategoryId[category._id] || [];

          return (
            <section key={category._id} className="w-full">
              <div className="flex justify-between items-end mb-6 pb-4">
                <div>
                  <h2 className="text-xl sm:text-2xl font-bold text-gray-900 m-0 tracking-wide">
                    {category.name}
                  </h2>
                  <p className="text-gray-400 text-xs mt-1.5 m-0">
                    {category.description || t('附专业技术，体现发型细节之美')}
                  </p>
                </div>
                <span 
                  onClick={() => handleNavigate(`/technical/detail/${category._id}`, { fromPrimary: true })}
                  className="text-[12px] sm:text-[13px] text-gray-400 hover:text-black font-semibold cursor-pointer transition-colors flex items-center gap-1"
                >
                  {t('查看更多')} &rarr;
                </span>
              </div>

              {matchingTechnicals.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
                  {matchingTechnicals.map((item) => (
                    <div 
                      key={item.id} 
                      onClick={() => handleNavigate(`/technical/${item.technicalsId}`)}
                      className="cursor-pointer bg-white rounded-lg overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col h-full"
                    >
                      <div className="w-full aspect-[4/3] overflow-hidden relative">
                        <img src={item.coverImage || item.coverimage || item.image || item.imageUrl || item.imagePath} alt={item.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                      </div>
                      <div className="p-5 sm:p-6 flex flex-col flex-1">
                        <h3 
                          className="text-[15px] sm:text-base font-bold text-gray-900 leading-snug mb-3 line-clamp-1 cursor-pointer hover:text-[#637cfb] transition-colors"
                        >
                          {item.title}
                        </h3>
                        <p className="text-gray-500 text-xs sm:text-[13px] leading-relaxed line-clamp-3 mb-6 flex-1">
                          {item?.subtitle}
                        </p>
                        <div className="flex justify-between items-center pt-4 border-t border-gray-50 mt-auto">
                          <span className="text-[12px] text-gray-400">
                            {t('text_read_time')}: {formatReadingTime(item?.readingTime)}
                          </span>
                          <span 
                            onClick={() => handleNavigate(`/technical/${item.technicalsId}`)}
                            className="text-[12px] gradient-text-button font-bold cursor-pointer transition-colors"
                          >
                            {t('text_in_depth')} &rarr;
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="w-full py-8">
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('text_no_content')} />
                </div>
              )}
            </section>
          );
        })}

        {/* ── Section 3: 在线课堂 (Online Classroom) ── */}
        <section className="w-full">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-end mb-6 border-b border-gray-100 pb-4 gap-4">
            <div>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 m-0 tracking-wide">
                {t('menu_online_class')}
              </h2>
            </div>
            
            {/* Filter Tabs + View More */}
            <div className="flex items-start justify-between sm:justify-end gap-6 sm:gap-10">
              <div className="flex gap-4 sm:gap-6 text-[13px] sm:text-[14px] font-semibold overflow-x-auto [&::-webkit-scrollbar]:hidden">
                {courseCategories.map((tab) => {
                  const isActive = activeTab === (tab._id || tab.id);
                  return (
                    <div
                      key={tab._id || tab.id}
                      onClick={() => { setActiveTab(tab._id || tab.id); setClassroomPage(1); }}
                      className={`cursor-pointer pb-2 relative transition-colors whitespace-nowrap duration-200 ${
                        isActive ? 'text-black font-bold' : 'text-gray-400 hover:text-black'
                      }`}
                    >
                      {t(tab.name)}
                      {isActive && (
                        <span className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#df97fb] via-[#7887fd] to-[#50c7f8] rounded-full" />
                      )}
                    </div>
                  );
                })}
              </div>
              <span 
                onClick={() => navigate('/online-class')}
                className="text-[13px] sm:text-[14px] text-gray-400 hover:text-black font-semibold cursor-pointer transition-colors flex items-center gap-1 whitespace-nowrap"
              >
                {t('查看更多')} &rarr;
              </span>
            </div>
          </div>

          {loadingTeachers ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 sm:gap-6">
              {Array.from({ length: 8 }).map((_, i) => (
                <div key={i} className="w-full aspect-[3/4] rounded-lg bg-gray-50 flex items-center justify-center overflow-hidden border border-gray-100">
                  <Skeleton.Image className="!w-full !h-full" active />
                </div>
              ))}
            </div>
          ) : teachers.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 sm:gap-6">
              {teachers.map((item) => (
                <div 
                  key={item._id}
                  onClick={() => navigate(`/online-class/${item.courseId || item._id || item.id}`)}
                  className="group relative overflow-hidden rounded-lg shadow-sm hover:shadow-md cursor-pointer aspect-[3/4] bg-gray-50 flex flex-col justify-end"
                >
                  {/* Background profile image */}
                  <img 
                    src={item?.picUrl} 
                    alt={item?.name} 
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" 
                  />
                  
                  {/* Gradient bottom overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent z-0" />
                  
                  {/* Profile detail text */}
                  <div className="p-4 z-10 w-full text-center">
                    <h4 className="text-white text-xs sm:text-sm font-bold m-0 tracking-wide">
                      {item?.name}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="w-full py-8">
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('text_no_teacher')} />
            </div>
          )}

          {totalTeachers > 0 && (
            <div className="flex justify-end mt-10">
              <CustomPagination
                current={classroomPage}
                pageSize={teacherPageSize}
                total={totalTeachers}
                onChange={(page, limit) => {
                  if (limit !== teacherPageSize) {
                    setTeacherPageSize(limit);
                    setClassroomPage(1);
                  } else {
                    setClassroomPage(page);
                  }
                }}
              />
            </div>
          )}
        </section>

      </div>
    </div>
    <AuthModal ref={authModalRef} />
    <PROModal open={isMemberGateOpen} onCancel={() => setIsMemberGateOpen(false)} />
    </>
  );
}
